import styled, { css } from "styled-components";

export const Header = styled.div`
  position: relative;
  height: 72px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 32px;
  background: linear-gradient(180deg, rgba(6, 7, 10, 0.85) 0%, rgba(6, 7, 10, 0.5) 70%, transparent 100%);
  backdrop-filter: blur(6px);
  z-index: 2;

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;

    div {
      color: var(--text);
      background: var(--panel);
      border: 1px solid var(--border);
      border-radius: 8px;
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'JetBrains Mono', monospace;
      font-size: 17px;
      font-weight: 700;
      cursor: default;
      transition: all 0.18s ease;
      user-select: none;
      box-shadow:
        0 2px 8px rgba(0, 0, 0, 0.4),
        inset 0 1px 0 rgba(255, 255, 255, 0.04);

      &:hover {
        background: var(--panel-2);
        border-color: var(--accent);
        color: var(--accent);
        transform: translateY(-2px);
      }
    }
  }
`;

export const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;

export const Chip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  font-family: 'JetBrains Mono', monospace;
  color: var(--text-dim);
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);

  strong {
    color: var(--text);
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1px;
  }

  ${(p) =>
    p.$highlight &&
    css`
      border-color: var(--warn);
      strong {
        color: var(--warn);
        text-shadow: 0 0 12px rgba(251, 191, 36, 0.5);
      }
    `}
`;

export const Mult = styled.span`
  color: var(--warn);
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1px;
  text-shadow: 0 0 10px rgba(251, 191, 36, 0.7);
  margin-left: 2px;
`;

export const Right = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;

export const MiniStat = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  font-family: 'JetBrains Mono', monospace;
  color: var(--text-dim);
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);

  strong {
    color: var(--text);
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }
`;

export const Score = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-dim);
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  letter-spacing: 3px;
  text-transform: uppercase;
  padding: 8px 16px;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  min-height: 32px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);

  strong {
    color: var(--accent);
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 1px;
    text-align: right;
    text-shadow: 0 0 12px var(--accent-glow);
  }
`;
